// Per-user evidence usage aggregate. The auth verdict is read here.
//
// THE GATE IS `skipToken`, NOT `enabled: false`. A disabled query can still be
// refetched; a `skipToken` query cannot, and the trial-recap surface branches
// on that state.
import { skipToken, useQuery } from '@tanstack/react-query';

import {
  EVIDENCE_USAGE_STATS_QUERY_KEY,
  type EvidenceUsageStatsResponse,
} from '../../contracts';
import { getEvidenceUsageStats } from '../api/userActivity';
import { useIsAuthenticated } from '../injected';

/**
 * GET /api/v2/ml-scribe/user-activity/evidence
 *
 * Per-user evidence usage stats for surfaces such as the 90-day trial recap modal.
 */
export function useQueryEvidenceUsageStats(enabled: boolean) {
  const canRead = useIsAuthenticated() && enabled;

  return useQuery({
    queryKey: [EVIDENCE_USAGE_STATS_QUERY_KEY],
    queryFn: canRead
      ? async (): Promise<EvidenceUsageStatsResponse> => getEvidenceUsageStats()
      : skipToken,
    staleTime: 60 * 1000,
  });
}
